
import { defineComponent, onMounted, ref, computed } from "vue";
import UserAvatar from "@/components/UserAvatar.vue";
import ApiService from "@/core/services/ApiService";
import DatePicker from "vue3-persian-datetime-picker";

import Notice from "@/components/Notice.vue";
import { useRoute } from "vue-router";
import { translate ,  getLocale, } from "@/core/services/HelpersFun";
export default defineComponent({
  name: "kt-commission-user",
   
    components: { Notice, UserAvatar, DatePicker, },
  setup() {
    const route = useRoute();

    const endPoint = computed(() => {
      if (route.path === `/management/cooperationInSales/${route.params.id}`) {
        return `/admin/user/${route.params.id}/financial-logs?page=${page.value}&code=commission`;
      }
      return `/user/financial-logs?page=${page.value}&code=commission`;
    });

    const loading = ref(true);
    const list = ref();
    const pagination = ref();
    const page = ref(1);
    const total_commissions = ref(0);

    const from_date = ref();
    const to_date = ref();
    const minDate = ref(new Date().toISOString().split("T")[0]);

    const getList = () => {
      loading.value = true;
      ApiService.setHeader();
      ApiService.query(endPoint.value, {
        params: { from_date: from_date.value, to_date: to_date.value },
      })
        .then(({ data }) => {
          loading.value = false;
          list.value = data.data.logs.data;
          pagination.value = data.data.logs.pagination;
          total_commissions.value = data.data.total_commissions;
        })
        .catch(() => {
          loading.value = false;
        });
    };

    onMounted(() => {
      getList();
    });

    const handleCurrentChange = (val: number) => {
      page.value = val;
      getList();
    };

    return {
      loading,
      list,
      pagination,
      total_commissions,
      handleCurrentChange,
      translate,

      from_date,
      to_date,
      minDate,
      getLocale,
      getList,
    };
  },
});
